<template>
  <a :href="data.website" target="_blank" :aria-label="data.name">
    <img
      :class="data.tier"
      :src="require(`@/assets/partnerLogos/${data.logo}`)"
      :style="`border-radius: ${data.borderRadius}`"
  /></a>
</template>

<script>
export default {
  name: "PartnerLogo",
  props: {
    data: Object,
  },
  methods: {},
  computed: {},
};
</script>

<style scoped lang="scss">
.large {
  max-height: 150px;
}
.medium {
  max-height: 75px;
}
.small {
  max-height: 50px;
}
</style>
